<template>
  <div class="goodList w_100 flex">
    <div class="item" v-for="(item, index) in list" :key="index">
      <div
        class="imgBox flex justify_c align_c"
        @click="jumpto('details', item.id)"
      >
        <img :src="item.image" alt="" />
      </div>
      <div
        class="name f_c_grey cursor hover"
        @click="jumpto('details', item.id)"
      >
        {{ item.title }}&nbsp;{{ item.subtitle }}
      </div>
      <div class="type">
        <span>现货</span>
      </div>
      <div v-if="token" class="money f_c_red">￥{{ item.price }}</div>
      <div v-else class="money f_c_red cursor" @click="jumpto('login')">
        去登陆
      </div>
    </div>
    <el-empty class="auto" v-if="list == ''" description="暂无产品"></el-empty>
  </div>
</template>
<script>
export default {
  name: 'goodList',
  props: {
    list: Array,
  },
  data() {
    return {
      token: '',
    }
  },
  watch: {
    list: {
      handler(newValue, oldValue) {
        // console.log(newValue, oldValue);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.token = localStorage.getItem('token')
  },
  methods: {
    jumpto(page, id) {
      const routeData = {
        name: page,
        query: {
          id: id,
        },
      }
      const resolvedRoute = this.$router.resolve(routeData)
      window.open(resolvedRoute.href, '_blank')
    },
  },
}
</script>
<style lang="scss" scoped>
.goodList {
  background: $color_white;
  padding: 10px 0px;
  flex-wrap: wrap;
  .item {
    width: 20%;
    height: max-content;
    padding: 25px;
    padding-right: 0;
    .imgBox {
      width: 100%;
      height: 240px;
      margin-bottom: 10px;
      background: #f9fafd;
      img {
        width: 90%;
        // height: 90%;
      }
    }
    .type {
      margin: 6px 0;
      span {
        display: inline-block;
        background: $color_red;
        padding: 2px 4px;
        font-size: 11px;
        color: $color_white;
        width: fit-content;
        border-radius: 5px;
        overflow: hidden;
      }
    }
    .money {
      font-weight: 600;
    }
  }
}
</style>
